import { createApp as createVueApp } from 'vue'
import emitter from 'tiny-emitter/instance'

import Modal from './VueComponents/modal.vue'
import CartTimer from './VueComponents/cart-timer.vue'
import LoadingSpinner from './VueComponents/loading-spinner.vue'
import DoorSalesControls from './VueComponents/DoorSales/door-sales-controls.vue'

import { formatMoney } from 'accounting-js'
import { setupAxios } from './axiosSetup'
import { createUiVariantPlugin } from './VuePlugins/uiVariant'

export function currencyFormat(value) {
    if (value === '-') return value;
    return formatMoney(value, '$', 2, ',', ',');
}

export function formatFreeOrCurrency(value) {
    return value === 0 ? 'Free' : currencyFormat(value);
}

const addGlobalComponentsToVue = (app) => {
    app.component('modal', Modal)
    app.component('cart-timer', CartTimer)
    app.component('door-sales-controls', DoorSalesControls)
    app.component('loading-spinner', LoadingSpinner)
}

const addPostHogErrorTracking = (app) => {
    const handler = () => {
        app.config.errorHandler = (err, instance, info) => {
            console.error(err)
            window.posthog.captureException(err)
        }
    }

    if (window.posthog?.__loaded) {
        handler()
    } else {
        window.addEventListener('posthog:loaded', handler, { once: true })
    }
}

const createEventBus = () => {
    const EventBus = {
        $on: (...args) => emitter.on(...args),
        $once: (...args) => emitter.once(...args),
        $off: (...args) => emitter.off(...args),
        $emit: (...args) => emitter.emit(...args),
    };
    window.EventBus = EventBus;
    return EventBus;
};

export const EventBus = createEventBus()

export function createApp(component) {
    setupAxios();
    const app = createVueApp(component);
    app.use(createUiVariantPlugin());
    addGlobalComponentsToVue(app);
    addPostHogErrorTracking(app);
    return app;
}

export const getDefaultStripeOptions = () => ({
    apiVersion: '2024-06-20'
});